import { Injectable } from "@angular/core";
import { CanMatch, Route, Router, UrlSegment, UrlTree } from "@angular/router";
import { Observable, of, switchMap } from "rxjs";
import { AuthService } from "../auth.service";

@Injectable({
    providedIn: 'root'
})
export class HasUserRoleGuard implements CanMatch {
    /**
     * Constructor
     * @param _authService
     * @param _router
     */
    constructor(private _authService: AuthService, private _router: Router) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can match
     *
     * @param route
     * @param segments
     */
    canMatch(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._check(route, segments);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Check the authenticated status
     *
     * @param segments
     * @private
     */
    private _check(route: Route, segments: UrlSegment[]): Observable<boolean> | any {

        // Check the user roles
        if (!this._authService.hasrole(route)) {
            return this._router.navigateByUrl("dashboard");
        }
        // Allow the access
        return this._router.navigateByUrl("monitor");
        // return of(true);

        // Check the authentication status
        // return this._authService.check().pipe(
        //     switchMap((authenticated) => {

        //         // If the user is not authenticated...
        //         if ( !authenticated ) {
        //             // Redirect to the sign-in page with a redirectUrl param
        //             const redirectURL = `/${segments.join('/')}`;
        //             const urlTree = this._router.parseUrl(`sign-in?redirectURL=${redirectURL}`);

        //             return of(urlTree);
        //         }

        //         // Allow the access
        //         return of(true);
        //     })
        // );
    }
}